<template>
  <VChip
    v-if="content"
    v-bind="$attrs"
    :color="background"
    :text-color="color"
    variant="flat"
    :class="{ 'overImage':overImage }"
    class="banner font-weight-bold"
  >
    <span>{{ content }}</span>
  </VChip>
</template>

<script lang="ts" setup>
interface Props {
  content?: string | null
  overImage?: boolean
  color?: string
  background?: string
}

withDefaults(defineProps<Props>(), {
  content: null,
  overImage: false,
  color: 'white',
  background: 'primary'
})
</script>

<style lang="scss" scoped>
  .banner {
    border-radius: 0;
    text-transform: uppercase;
  }
  .overImage {
    position: absolute;
    z-index: 1;
  }
  .text {
    background-color: transparent;
    opacity: inherit;
    padding: 0;
    height: unset;
  }
</style>
